import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Tefl } from '../../lib/types/models/tefl/tefl'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTefls(olId: number, input?: PaginationRequest) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.tefl.getAllTeflByOlId.url, { olId }),
        input
      )
    )
    .get<PaginationResponse<Tefl>>()
}
